module.exports = __webpack_public_path__ + "fb5f7022cb14eca5192f9bf65aae77f4.svg";